const PropertyType = [
    {
        key: "House",
        name: "House"
    },
    {
        key: "Office",
        name: "Office"
    },
    {
        key: "Land",
        name: "Land"
    },
    {
        key: "Mall",
        name: "Shop/Mall"
    }
];

export default PropertyType;
